import React from "react"
import MyCalendar from "./pages/Calendar"
import DispatchAssignmentPage from "./pages/DispatchAssignment"
import { Toaster } from "react-hot-toast"

export default function App() {
  const pathname = window.location.pathname || ""
  const isDispatchAssignment = pathname.startsWith("/dispatch-public/assignment")
  const shouldNormalizeDispatchPath =
    isDispatchAssignment && pathname.includes("//")

  return (
    <div>
      {shouldNormalizeDispatchPath ? (
        <DispatchAssignmentPage />
      ) : (
        <MyCalendar />
      )}
      <Toaster />
    </div>
  )
}
